// imports
import AccordionGroup from 'minsky-kit/js/components/AccordionGroup';
import WADAccordion from './WADAccordion';
// private statics

// class definition
export default class WADAccordionGroup extends AccordionGroup {
    // constructor
    constructor (args = {}, objectName = 'AccordionGroup') {
        args.debug = args.debug || false;
        args.Accordion = WADAccordion;

        // super
        super(args, objectName);
    }

    // methods

    destroy () {
        super.destroy();
    }

    // getters & setters
}

// Utils

// Event handlers
